const CAMPAIGN_OPTIONS_STORAGE_KEY = 'techladder.scheduleCampaignNames';
export const DEFAULT_CAMPAIGN_NAME = 'NA';
export const CREATE_CAMPAIGN_VALUE = '__create_campaign__';

export function normalizeCampaignName(value) {
  const text = String(value || '').trim();
  return text || DEFAULT_CAMPAIGN_NAME;
}

function normalizeCampaignScope(scope) {
  const text = String(scope || '').trim();
  return text || 'global';
}

function getCampaignStorageKey(scope) {
  return `${CAMPAIGN_OPTIONS_STORAGE_KEY}.${normalizeCampaignScope(scope)}`;
}

export function loadCampaignNames(scope = 'global') {
  if (typeof window === 'undefined') return [];

  try {
    const parsed = JSON.parse(window.localStorage.getItem(getCampaignStorageKey(scope)) || '[]');
    if (!Array.isArray(parsed)) return [];
    return Array.from(
      new Set(
        parsed
          .map(normalizeCampaignName)
          .filter((name) => name && name !== DEFAULT_CAMPAIGN_NAME)
      )
    ).sort((a, b) => a.localeCompare(b));
  } catch {
    return [];
  }
}

export function saveCampaignName(value, scope = 'global') {
  const campaignName = normalizeCampaignName(value);
  if (campaignName === DEFAULT_CAMPAIGN_NAME || typeof window === 'undefined') {
    return loadCampaignNames(scope);
  }

  const nextNames = Array.from(new Set([...loadCampaignNames(scope), campaignName]))
    .sort((a, b) => a.localeCompare(b));
  window.localStorage.setItem(getCampaignStorageKey(scope), JSON.stringify(nextNames));
  return nextNames;
}

export function deleteCampaignName(value, scope = 'global') {
  const campaignName = normalizeCampaignName(value);
  if (campaignName === DEFAULT_CAMPAIGN_NAME || typeof window === 'undefined') {
    return loadCampaignNames(scope);
  }

  const nextNames = loadCampaignNames(scope).filter((name) => name !== campaignName);
  window.localStorage.setItem(getCampaignStorageKey(scope), JSON.stringify(nextNames));
  return nextNames;
}
